import React, { useEffect } from "react";

const ShippingPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <style>{`
        .policy-container {
          display: flex;
          justify-content: center;
          padding: 40px 20px;
        }

        .policy-card {
          background: #f9fafb;
          padding: 40px;
          border-radius: 16px;
          max-width: 900px;
          width: 100%;
          box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.08);
          font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
        }

        .policy-title {
          font-size: 32px;
          font-weight: 700;
          text-align: center;
          color: #1f2937;
          margin-bottom: 24px;
        }

        .policy-text {
          color: #4b5563;
          margin-bottom: 20px;
          text-align: justify;
          line-height: 1.7;
        }

        .policy-list {
          list-style: decimal;
          padding-left: 18px;
          color: #374151;
          line-height: 1.8;
        }

        .policy-list li {
          margin-bottom: 16px;
        }

        .policy-list span {
          font-weight: 600;
          color: #111827;
        }

        .policy-sublist {
          list-style: disc;
          margin-top: 8px;
          margin-left: 22px;
          color: #4b5563;
        }

        .policy-contact a {
          color: #2563eb;
          text-decoration: none;
        }

        .policy-contact a:hover {
          text-decoration: underline;
        }
      `}</style>

      <div className="policy-container">
        <div className="policy-card">
          <h2 className="policy-title">Shipping Policy</h2>

          <p className="policy-text">
            At{" "}
            <span style={{ fontWeight: "600" }}>Sri Mangalambika Stores</span>,
            we aim to deliver your products safely, quickly, and efficiently.
            Please read our shipping terms below:
          </p>

          <ol className="policy-list">
            <li>
              <span>Order Processing Time:</span> Orders are processed within{" "}
              <span>1–2 business days</span> after payment confirmation. Orders
              placed on weekends or public holidays will be processed on the
              next working day.
            </li>

            <li>
              <span>Shipping Methods & Delivery Time:</span> We ship across
              India through trusted courier partners like{" "}
              <i>Professional Courier, ST Courier, DTDC</i>.
              <ul className="policy-sublist">
                <li>Metro Cities: 3–4 business days</li>
                <li>Other Locations: 4–5 business days</li>
              </ul>
            </li>

            <li>
              <span>Shipping Costs:</span>
              <ul className="policy-sublist">
                <li>Orders below ₹2000: Delivery fee (location-based)</li>
                <li>Orders above ₹2000: Free shipping</li>
                <li>
                  International Orders: Shipping calculated at checkout (based
                  on volumetric weight). Currently, we do not ship outside
                  India.
                </li>
              </ul>
            </li>

            <li>
              <span>Order Tracking:</span> Once shipped, you’ll receive a
              tracking number & courier details via SMS/email. You can track
              your order on the courier’s website/app.
            </li>

            <li>
              <span>Delays & Unforeseen Circumstances:</span> Delivery may be
              delayed due to natural calamities, strikes, lockdowns, or courier
              partner issues. We’ll keep you updated on major delays.
            </li>

            <li>
              <span>Incorrect Address / Failed Delivery:</span> Ensure your
              shipping details are correct. If returned due to wrong address,
              non-availability, or refusal, reshipping charges may apply.
            </li>

            <li>
              <span>Damaged or Missing Items:</span> If your package arrives
              damaged or tampered, please refuse delivery and contact us
              immediately. For missing/incorrect items, notify us within{" "}
              <span>48 hours</span> of delivery with photos.
            </li>

            <li className="policy-contact">
              <span>Contact Us:</span>
              <div style={{ marginTop: "8px", lineHeight: "1.6" }}>
                📧{" "}
                <a href="mailto:srimangalambikastore@gmail.com" style={{fontSize:"15px"}}>
                  srimangalambikastore@gmail.com
                </a>
                <br />
                📞 WhatsApp/Phone:{" "}
                <span style={{ fontWeight: "500" }}>
                  6383786782, 9363700957
                </span>
              </div>
            </li>
          </ol>
        </div>
      </div>
    </>
  );
};

export default ShippingPolicy;
